import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, importProvidersFrom, inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { HttpClientModule, provideHttpClient } from '@angular/common/http';
import { AlertService } from '../../shared/services/alert.service';
import Intercom, { shutdown } from '@intercom/messenger-js-sdk';

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.css'
})
export class LoginPageComponent {
  @ViewChild('passwordInput') passwordInput!: ElementRef;

  form!: UntypedFormGroup;
  formReset!: UntypedFormGroup;
  loading = false;
  submitted = false;
  returnUrl!: string;
  viewPassword = false;
  requestResetPassword = false;
  data: any = {};
  isMobile: boolean = false;
  
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenSize();
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    public auth: AuthService,
  ) {
    // shutdown();
  }

  ngOnInit() {

    Intercom({
      app_id: 'ltkh63p1',
    });

    this.checkScreenSize()

    this.form = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    });

    this.formReset = this.formBuilder.group({
      email: ['', Validators.required]
    });

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.auth.logout();
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  async onSubmit() {
    this.f['email'].setValue(this.f['email'].value.trim());
    this.f['password'].setValue(this.f['password'].value.trim());

    this.submitted = true;

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    this.loading = true;

    try {
      await this.auth.login(this.form.value);
      this.alertService.success('Inicio de sesión exitoso');
      this.router.navigate(['/admin', 0, 'home']);
    }

    catch (e) {
      this.alertService.error('Usuario y/o contraseña inválidos');
      this.loading = false;
    }
  }

  togglePasswordView() {
    this.viewPassword = !this.viewPassword;
    this.passwordInput.nativeElement.type = this.viewPassword ? 'text' : 'password';
  }

  showRequestResetPassword() {
    this.requestResetPassword = true;
  }

  checkScreenSize() {
    this.isMobile = window.innerWidth < 768; // 768 es el punto de ruptura para md en Bootstrap
  }

  async onSubmitReset() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.formReset.invalid) {
      return;
    }

    this.loading = true;

    try {

      this.auth.passwordRequestReset(this.formReset.value).subscribe((result) => {
        if (result) {
          this.alertService.success('Solicitud de reseteo de clave enviada exitosamente \n revise su correo para continuar');
          this.requestResetPassword = false;
          this.loading = false;
        }
      });

    }

    catch (e) {
      console.log(e);
      this.loading = false;
    }
  }

}
